import { Component, EventEmitter, Input, OnChanges, Output, TemplateRef } from "@angular/core";
import { ILesson } from "../../../domain/models/lesson/lesson.model";
import { IPlanWeekItem } from "../../../domain/models/plan/plan-week-item.model";
import { DEFAULT_PLANNER_CONFIG, IPlannerConfig } from "../planner.model";

/**
 * The weekly plan grouped by lesson — the "Dersler" view: one column per lesson, its items inside.
 *
 * Presentational: it takes the week's items and hands every action back as an event.
 */
@Component({
  selector: "app-planner-board",
  templateUrl: "./planner-board.component.html",
  styleUrl: "./planner-board.component.scss",
})
export class PlannerBoardComponent implements OnChanges {
  @Input() lessons: ILesson[] = [];
  @Input() items: IPlanWeekItem[] = [];
  @Input() config: IPlannerConfig = DEFAULT_PLANNER_CONFIG;
  @Input() videoTemplate?: TemplateRef<{ $implicit: IPlanWeekItem }> | null;
  @Input() menuTemplate?: TemplateRef<{ $implicit: IPlanWeekItem }> | null;
  /** Rendered instead of the columns while the week is being fetched. */
  @Input() isLoading = false;

  @Output() addTopicRequested = new EventEmitter<ILesson>();
  @Output() itemToggled = new EventEmitter<IPlanWeekItem>();
  @Output() itemTransferRequested = new EventEmitter<IPlanWeekItem>();
  @Output() itemDuplicateRequested = new EventEmitter<IPlanWeekItem>();
  @Output() itemRemoveRequested = new EventEmitter<IPlanWeekItem>();
  @Output() itemMenuOpened = new EventEmitter<IPlanWeekItem>();

  /** Items of each lesson, keyed by lesson id. */
  itemsByLesson: Record<number, IPlanWeekItem[]> = {};

  ngOnChanges(): void {
    this.itemsByLesson = this.items.reduce((grouped, item) => {
      if (!item.lessonId) {
        return grouped;
      }

      const bucket = grouped[item.lessonId] ?? [];
      bucket.push(item);
      grouped[item.lessonId] = bucket;
      return grouped;
    }, {} as Record<number, IPlanWeekItem[]>);
  }

  /** Lessons that either belong to the plan or already carry an item this week. */
  visibleLessons(): ILesson[] {
    return this.lessons.filter(lesson => !!lesson);
  }
}
